module.exports = __webpack_public_path__ + "img/image@2x (1).0610520e.webp";